// 1. 서버 통신 및 내부 식별용
export const tutorialPageKeys = {
  HOME: 'main',
  WORD_DICTIONARY: 'word_dictionary',
  CONVERSATION_NOTE: 'conversation_note',
  REPORT: 'report',
  WORD_RECORD: 'word_record',
  WORD_CARD_RECORD: 'word_card_record',
  CONVERSATION_RECORD: 'conversation_record',
};

// 2. URL 경로
export const tutorialUrlMaps = {
  'main': 'HOME',
  'word-dictionary': 'WORD_DICTIONARY',
  'conversation-note': 'CONVERSATION_NOTE',
  'report': 'REPORT',
  'word-record': 'WORD_RECORD',
  'word-card-record': 'WORD_CARD_RECORD',
  'conversation-record': 'CONVERSATION_RECORD',
  'child-voice-register': 'CHILD_VOICE_REGISTER'
};